(function () {
  const HIDDEN_MAIN = "product__media-item--variant-hidden";
  const HIDDEN_SUB = "product__media-subitem--variant-hidden";

  function handleize(str) {
    return String(str || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/'/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-+/g, "-");
  }

  function getMediaRoot(sectionId) {
    if (!sectionId) return null;
    return (
      document.querySelector(
        `[data-section="product-media-${sectionId}"][data-alt-media-grouping="true"]`
      ) ||
      document.querySelector(
        `[data-section="product-media-${sectionId}"]`
      )
    );
  }

  function matchesAltGroup(el, selectedGroup) {
    const group = (el.dataset.mediaGroup || "").trim();
    if (!group) return true;
    return group === selectedGroup;
  }

  function setItemVisibility(el, visible, hiddenClass) {
    el.classList.toggle(hiddenClass, !visible);

    const parent = el.parentElement;
    const inSwiperWrapper = parent?.classList.contains("swiper-wrapper");
    if (inSwiperWrapper) {
      el.classList.toggle("swiper-slide", visible);
    }
  }

  function rememberDirection(swiper) {
    if (!swiper) return null;
    if (typeof swiper.isVertical === "function" && swiper.isVertical()) {
      return "vertical";
    }
    if (typeof swiper.isHorizontal === "function" && swiper.isHorizontal()) {
      return "horizontal";
    }
    return swiper.params?.direction || null;
  }

  function restoreDirection(swiper, direction) {
    if (!swiper || !direction) return;
    const current =
      typeof swiper.isVertical === "function" && swiper.isVertical()
        ? "vertical"
        : "horizontal";
    if (current !== direction && typeof swiper.changeDirection === "function") {
      swiper.changeDirection(direction, false);
    }
  }

  function refreshSwiper(swiper) {
    if (!swiper) return;
    const direction = rememberDirection(swiper);

    if (typeof swiper.updateSize === "function") swiper.updateSize();
    if (typeof swiper.updateSlides === "function") swiper.updateSlides();
    if (typeof swiper.updateProgress === "function") swiper.updateProgress();
    if (typeof swiper.updateSlidesClasses === "function") {
      swiper.updateSlidesClasses();
    }
    swiper.update();

    restoreDirection(swiper, direction);
  }

  function findFeaturedSlideIndex(sliderEl, sectionId, variant) {
    if (!sliderEl?.swiper || !variant?.featured_media?.id) return -1;

    const mediaId = String(variant.featured_media.id);
    const fullKey = `${sectionId}-${mediaId}`;

    return sliderEl.swiper.slides.findIndex((slide) => {
      if (slide.classList.contains(HIDDEN_MAIN)) return false;
      const key = slide.dataset.mediaId;
      return key === fullKey || key === mediaId || key?.endsWith(`-${mediaId}`);
    });
  }

  function updateThumbsVisibility(mediaRoot) {
    const thumbsOuter = mediaRoot.querySelector(
      ".product__media-sublist-outer"
    );
    if (!thumbsOuter) return;

    const visibleThumbs = mediaRoot.querySelectorAll(
      `[data-media-sub-id]:not(.${HIDDEN_SUB})`
    );
    thumbsOuter.classList.toggle("hidden", visibleThumbs.length <= 1);
  }

  function getSelectedGroup(mediaRoot, variant) {
    const position = Number(mediaRoot.dataset.groupOptionPosition || 0);
    if (!position || !variant?.options?.length) return "";
    return handleize(variant.options[position - 1] || "");
  }

  window.updateVariantMediaDisplay = function updateVariantMediaDisplay(
    sectionId,
    variant
  ) {
    const mediaRoot = getMediaRoot(sectionId);
    if (!mediaRoot || mediaRoot.dataset.altMediaGrouping !== "true") {
      return;
    }

    const selectedGroup = getSelectedGroup(mediaRoot, variant);

    mediaRoot.querySelectorAll("[data-media-id]").forEach((el) => {
      if (!el.classList.contains("product__media-item")) return;
      const visible = matchesAltGroup(el, selectedGroup);
      setItemVisibility(el, visible, HIDDEN_MAIN);
    });

    mediaRoot.querySelectorAll("[data-media-sub-id]").forEach((el) => {
      if (!el.classList.contains("product__media-subitem")) return;
      const visible = matchesAltGroup(el, selectedGroup);
      setItemVisibility(el, visible, HIDDEN_SUB);
    });

    const mainSlider = mediaRoot.querySelector(".js-media-list");
    const thumbsSlider = mediaRoot.querySelector(".js-media-sublist");

    refreshSwiper(mainSlider?.swiper);
    refreshSwiper(thumbsSlider?.swiper);

    updateThumbsVisibility(mediaRoot);

    const mainSwiper = mainSlider?.swiper;
    if (mainSwiper) {
      let slideIndex = findFeaturedSlideIndex(mainSlider, sectionId, variant);
      if (slideIndex < 0) slideIndex = 0;
      if (mainSwiper.slides.length > 0) {
        mainSwiper.slideTo(slideIndex, 0);
      }
    }

    if (thumbsSlider?.swiper && mainSlider?.swiper) {
      thumbsSlider.swiper.slideTo(mainSlider.swiper.activeIndex, 0);
    }
  };

  function getSelectedVariantFromSection(sectionId) {
    const picker = document.querySelector(
      `variant-selects[data-section="${sectionId}"], variant-radios[data-section="${sectionId}"]`
    );
    const script =
      picker?.querySelector("[data-selected-variant]") ||
      document.querySelector(
        `#MainProduct-${sectionId} [data-selected-variant], #shopify-section-${sectionId} [data-selected-variant]`
      );
    if (!script?.textContent?.trim()) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function initAltMediaGrouping(root = document) {
    root
      .querySelectorAll('[data-alt-media-grouping="true"]')
      .forEach((mediaRoot) => {
        const sectionAttr = mediaRoot.dataset.section || "";
        const sectionId = sectionAttr.replace(/^product-media-/, "");
        if (!sectionId) return;
        const variant = getSelectedVariantFromSection(sectionId);
        window.updateVariantMediaDisplay(sectionId, variant);
      });
  }

  document.addEventListener("DOMContentLoaded", () => initAltMediaGrouping());
  document.addEventListener("shopify:section:load", (event) => {
    initAltMediaGrouping(event.target);
  });
})();
